<template lang="html">
  <section class="reg--steps">
    <div class="row--wrapper">
      <ol class="reg-steps--list">
        <li
          class="reg-steps--list-item"
          :class="classes[0]"
        >
          Cadastro Inicial
        </li>
        <li
          class="reg-steps--list-item"
          :class="classes[1]"
        >
          Informações Pessoais
        </li>
        <li
          class="reg-steps--list-item"
          :class="classes[2]"
        >
          Renda e Banco
        </li>
        <li
          class="reg-steps--list-item"
          :class="classes[3]"
        >
          Detalhes do empréstimo
        </li>
        <li
          class="reg-steps--list-item"
          :class="classes[4]"
        >
          Assine o Contrato
        </li>
      </ol>
    </div>
  </section>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  computed: {
    currentStepNumber: get('registration/currentStepNumber'),
    classes() {
      return this.lodash.map(this.lodash.range(1, 6), (i) => ({
        active:   this.currentStepNumber === i,
        complete: this.currentStepNumber > i,
      }));
    },
  },
};
</script>
<style lang="scss" module>
  .reg--steps {
    margin: 1em auto;
    width: 95%;
    font-size: 16px;
  }
</style>
